export interface ProjectLink {
  icon: string;
  tag: string;
  link: string;
}

export interface Project {
  name: string;
  desc: string;
  links: ProjectLink[];
  techstack: string[];
}

export const projects: Project[] = [
  {
    name: "Early heart failure detection via ECG and AI",
    desc: "Built an interpretable AI pipeline using 12-lead ECGs for early heart failure detection, achieving 89% accuracy with a lightweight web interface for real-time predictions. Deployed on AWS EC2 & S3",
    links: [
      {
        icon: "fa-solid fa-globe",
        tag: "Web",
        link: "http://heart-failure-detection-frontend.s3-website-ap-southeast-2.amazonaws.com/",
      },
      {
        icon: "fa-brands fa-github",
        tag: "FrontEnd",
        link: "https://github.com/AshanMSilva/heart-failure-detection-frontend",
      },
      {
        icon: "fa-brands fa-github",
        tag: "BackEnd",
        link: "https://github.com/AshanMSilva/heart-failure-detection-rest-api",
      },
      {
        icon: "fa-brands fa-github",
        tag: "ML Training",
        link: "https://github.com/AshanMSilva/Early-Heart-Failure-Detection-via-AI-and-ECG",
      },
    ],
    techstack: [
      "Python",
      "Django",
      "React",
      "AWS",
      "EC2",
      "S3",
      "GitHub",
      "GitHub Actions",
      "CNN",
      "XGBoost",
      "SVM",
      "Random Forest",
    ],
  },
  {
    name: "Finance Houses Association of Sri Lanka - Website and Dashboard",
    desc: "Public front-end and dashboard to handle publicly visible data and internal data of multiple financial institutions.",
    links: [
      {
        icon: "fa-solid fa-globe",
        tag: "Web",
        link: "https://fha-lanka-dev.web.app/",
      },
      {
        icon: "fa-brands fa-github",
        tag: "Dashboard",
        link: "https://github.com/AshanMSilva/fha-dashboard",
      },
      {
        icon: "fa-brands fa-github",
        tag: "Front-End",
        link: "https://github.com/AshanMSilva/fha-frontend",
      },
      {
        icon: "fa-brands fa-github",
        tag: "Cloud Functions",
        link: "https://github.com/AshanMSilva/fha-cloud",
      },
    ],
    techstack: [
      "Angular",
      "TypeScript",
      "Firebase",
      "Serverless-Architecture",
      "Firebase Hosting",
      "GCP",
      "Cloud Functions",
    ],
  },
  {
    name: "Shark Travels",
    desc: "A simple web application for 'Shark Travels' to handle their business.",
    links: [
      {
        icon: "fa-solid fa-globe",
        tag: "Web",
        link: "https://shark-travels-61661.web.app/",
      },
      {
        icon: "fa-brands fa-github",
        tag: "FrontEnd",
        link: "https://github.com/AshanMSilva/Shark-Travelshttps://github.com/AshanMSilva/Shark-Travels",
      },
      {
        icon: "fa-brands fa-github",
        tag: "Cloud Functions",
        link: "https://github.com/AshanMSilva/Shark-Travels-Cloud",
      },
    ],
    techstack: ["Angular", "TypeScript", "Firebase", "Cloud Functions"],
  },
  {
    name: "Fortify Asia",
    desc: "A web application for connecting ideas and projects to experts all across Asia.",
    links: [
      {
        icon: "fa-solid fa-globe",
        tag: "Web",
        link: "https://www.fortify-asia.com/",
      },
    ],
    techstack: ["React", "JavaScript", "NestJs", "TypeScript", "MongoDB"],
  },
  {
    name: "Drawing GIF : Meme & GIF Maker",
    desc: "Drawing desk with an awesome color palette to draw your best painting.",
    links: [
      {
        icon: "fa-solid fa-globe",
        tag: "Web",
        link: "https://apps.apple.com/us/app/drawing-gif-meme-gif-maker/id1540431667",
      },
    ],
    techstack: ["Flutter", "Dart", "Google Playstore", "Appstore"],
  },

  {
    name: "Gem Certification Platform for Serendip Gem Testing Lab",
    desc: "Generate and Store PDF certificates for Gems, with two formats with QR back-links to verify the certificates.",
    links: [
      {
        icon: "fa-brands fa-github",
        tag: "Code",
        link: "https://github.com/AshanMSilva/gem-site",
      },
    ],
    techstack: [
      "Angular",
      "TypeScript",
      "Firebase",
      "Serverless-Architecture",
      "GCP",
    ],
  },
  {
    name: "Roux & Glamour",
    desc: "E-Commerce platform designed for a jewelry business client. Includes an administration dashboard for managing products, vendors and orders. Customer application consists of features: Browsing, filtering and searching jewelry products, Manage shopping cart, online payment.",
    links: [
      {
        icon: "fa-brands fa-github",
        tag: "Dashboard",
        link: "https://github.com/AshanMSilva/Chains-and-charms-Dashboard",
      },
      {
        icon: "fa-brands fa-github",
        tag: "Front-End",
        link: "https://github.com/AshanMSilva/Chains-and-charms-Client-Side",
      },
      {
        icon: "fa-brands fa-github",
        tag: "Back-End",
        link: "https://github.com/AshanMSilva/Chains-and-charms-Backend",
      },
    ],
    techstack: [
      "Angular",
      "NodeJs",
      "ExpressJs",
      "JavaScript",
      "TypeScript",
      "MongoDB",
      "JWT",
      "Heroku",
      "AWS S3",
    ],
  },
  {
    name: "Social Media Analysis in Semester 5",
    desc: "Did a group project aiming the software engineering project module. It was a web application developed for the analysis of Twitter, Facebook, Stack Overflow and YouTube. There, I was engaged in Twitter & building the forum for the website. I used python for the implementation and tweepy API to extract data.",
    links: [
      {
        icon: "fa-brands fa-github",
        tag: "Code",
        link: "https://github.com/AshanMSilva/Social-Media-Analysis",
      },
    ],
    techstack: ["Flask", "Python", "HTML", "Twitter API"],
  },
  {
    name: "Twitter Analytics",
    desc: "worked on a mobile application designed using ionic and angular frameworks to analyze Twitter with the options to search account, predict bot account and analyze hashtags. To extract data to this app I created a simple rest API using Django and it's deployed in Heroku. Later, the app is implemented using Flutter",
    links: [
      {
        icon: "fa-brands fa-github",
        tag: "Ionic",
        link: "https://github.com/AshanMSilva/TwitterAnalyticsApp",
      },

      {
        icon: "fa-brands fa-github",
        tag: "Flutter",
        link: "https://github.com/AshanMSilva/twitter_analytics_pro",
      },
      {
        icon: "fa-brands fa-github",
        tag: "API",
        link: "https://github.com/AshanMSilva/social-media-analysis-api",
      },
    ],
    techstack: [
      "Django",
      "Ionic",
      "Twitter API",
      "Flutter",
      "Dart",
      "TypeScript",
      "Python",
      "Heroku",
    ],
  },
  {
    name: "GPA Calculator",
    desc: "I have implemented a simple GPA calculator using ionic and angular frameworks. Currently it has a built-in database for the modules in university of Moratuwa, university of Peradeniya and SLIIT. It has the feature of customizing modules at any time and a user can keep multiple accounts at the same time.",
    links: [
      {
        icon: "fa-brands fa-github",
        tag: "Code",
        link: "https://github.com/AshanMSilva/GPACalculator",
      },
    ],
    techstack: [
      "Ionic Framework",
      "Mobile Application Development",
      "TypeScript",
    ],
  },
  {
    name: "Single Vendor E-Commerce Platform",
    desc: "Online sales management web application which consists of functionalities: Categorical display of products, Storing dynamic attributes of each product variant, Shopping Cart, Customer registration and Order management.",
    links: [
      {
        icon: "fa-brands fa-github",
        tag: "Code",
        link: "https://github.com/AshanMSilva/Single-Vendor-E-Commerce-Platform",
      },
    ],
    techstack: ["PHP", "Bootstrap", "HTML", "MySQL", "JavaScript"],
  },
];
